import { Access } from './Role.interfaces';

export type User = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  companyID: string[];
  roles: { id: string; name: string }[];
  isAdmin: boolean;
  type: string;
  vpUser?: string;
  lastAccess?: Date;
  deletedAt?: Date;
  access?: Access[];
  securityGroups?: number[];
};

export type UserSummary = {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
};

export type UsersData = {
  users: UserSummary[];
  totalUsers: number;
};

export enum CompanySource {
  ViewPoint = 'ViewPoint',
  Yardi = 'Yardi',
  Mask = 'Mask',
}

export type Company = {
  source: CompanySource;
  id: string;
  code: string;
  alias?: string;
  name: string;
  address: string;
  address2: string;
  phone: string;
  city: string;
  state: string;
  zip: string;
  udAbbrev: string;
  isActive: boolean;
  mask?: { id: string; code: string; source: CompanySource };
};

export type CompanySummary = {
  id: string;
  code: string;
  name: string;
  source: CompanySource;
  isActive: boolean;
};

export type USFilterFields = 'info' | 'roles' | 'userType' | 'isAdmin';

export type VPUser = {
  VPUserName: string;
  FullName: string;
  Email?: string;
};

export type UserPreference = {
  id: string;
  section: string;
  name: string;
  userID: string;
  preference: unknown;
  createdAt: Date;
  updatedAt: Date;
};
